import { css } from '@emotion/react';
import React from 'react';
import t from 'react-translate';
import RecruitmentForm from './recruitment-form';
import { PROGRAM_CONFIGURATION_SECTION_WIDTH } from '../../constants';


const styles = css`
  max-width: ${PROGRAM_CONFIGURATION_SECTION_WIDTH}px;
`;

const Recruitment = () => (
  <div css={styles} className='mx-auto'>
    <div className='title heading-2 mb-2'>
      {t.MENTORING_PROGRAMS.SETTINGS.TABS.RECRUITMENT.TITLE()}
    </div>
    <div className='text-body black mb-6'>
      {t.MENTORING_PROGRAMS.SETTINGS.TABS.RECRUITMENT.DESCRIPTION()}
    </div>
    <RecruitmentForm />
  </div>
);

export default Recruitment;
